export default "__VITE_ASSET__8c2df287__"